import { useState, useEffect } from 'react';

export function useScrollVisibility(threshold = 10): boolean {
  const [visible, setVisible] = useState(true);
  const [lastY, setLastY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      // Show header when scrolling down, hide when scrolling up,
      // but always show near the very top of the page.
      setVisible(y > lastY || y < threshold);
      setLastY(y);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastY, threshold]);

  return visible;
}
